<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-01 20:05:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-05 09:46:13
-->
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled="readonly"
                       :showReturn="false"
                       :showEdit="hasBtn('edit-value-internationalization-configuration')"
                       :show_del="false"
                       @handleEdit="handleEdit"></mrc_ess_iconGroup>
    <div class="bigbox">
      <template v-for="(item, index) in list">
        <valueint :list="item"
                  :readonlyed="readonly"
                  :disabled="readonly"
                  :key="index"
                  @getchildrenlist="getchildrenlist"></valueint>
      </template>
    </div>
    <mrc_ess_submitBtn @success="success"
                       @cancel="cancel"
                       :loading="btnIsLoading"
                       v-if="!readonly"></mrc_ess_submitBtn>
  </div>
</template>

<script>
import { valuedetail, valueupdate } from '@/service/api/internationalization.js'
import valueint from './valueint'
export default {
  components: {
    valueint,
  },
  props: {},
  data () {
    return {
      btnIsLoading: false,
      readonly: true, //默认只读
      list: [
        // {
        //   is_international: 0,
        //   uuid: '222222222',
        //   table_description: '3232',
        //   mrbase_sys_datamodel_field: [
        //     {
        //       field_uuid: '',
        //       field_name: 'aaada',
        //       field_description: '11111',
        //       is_international: 0
        //     },
        //     {
        //       field_uuid: '',
        //       field_name: 'vsasvava',
        //       field_description: '333333333',
        //       is_international: 0
        //     }
        //   ]
        // }
      ],
      item: 1,
      parentlist: [],
    }
  },
  created () { },
  async mounted () {
    await this.getdetail()
    this.readonly = this.$store.state.iconstatus
  },
  methods: {
    getchildrenlist (v) {
      const index = this.parentlist.findIndex((item) => {
        return item.uuid == v.uuid
      })
      if (index != -1) this.$set(this.parentlist, index, v)
      else this.$set(this.parentlist, this.parentlist.length, v)
      // console.log(this.parentlist);
    },
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    async getdetail () {
      const module_name = this.$store.state.subPage_name
      const res = await valuedetail({
        module_uuid: this.$store.state.uuid,
      })
      if (res.code == 200) {
        res.data.map((item) => {
          item.mrbase_sys_datamodel_field.map((item1) => {
            if (item1.is_international == '') item1.is_international = 0
          })
        })
        // res.data.push({
        //   is_international: 0,
        //   uuid: '222222222',
        //   table_description: '3232',
        //   mrbase_sys_datamodel_field: [
        //     {
        //       field_uuid: '434',
        //       field_name: 'aaada',
        //       field_description: '11111',
        //       is_international: 0
        //     },
        //     {
        //       field_uuid: '22',
        //       field_name: 'vsasvava',
        //       field_description: '333333333',
        //       is_international: 0
        //     }
        //   ]
        // })
        this.list = res.data
        // console.log(this.list);
      }
    },
    success () {
      this.btnIsLoading = true
      let table_uuids = ''
      let field_uuids = ''
      let not_table_uuids = ''
      //先判断是否全部选中 未全选选中则进入
      this.parentlist.forEach((item) => {
        if (item.is_international == 1) {
          // console.log('全选');
          table_uuids += item.uuid + ','
          item.mrbase_sys_datamodel_field.forEach((item1) => {
            if (item.is_international == 1) {
              // console.log('次数');
              field_uuids += item1.field_uuid + ','
            }
          })
        } else {
          if (item.mrbase_sys_datamodel_field.length > 0) {
            let isstatus = true
            item.mrbase_sys_datamodel_field.forEach((item2) => {
              if (item2.is_international == 1) {
                field_uuids += item2.field_uuid + ','
                isstatus = false
              }
            })
            if (!isstatus) {
              table_uuids += item.uuid + ','
            }
          }
        }
      })

      this.parentlist.forEach((item) => {
        if (item.is_international == 0) {
          const isno = item.mrbase_sys_datamodel_field.some((item1) => {
            return item1.is_international == 1
          })
          if (!isno) {
            not_table_uuids += item.uuid + ','
          }
        }
      })
      table_uuids =
        table_uuids == ''
          ? (table_uuids = 0)
          : table_uuids.substring(0, table_uuids.length - 1)
      field_uuids =
        field_uuids == ''
          ? (field_uuids = 0)
          : field_uuids.substring(0, field_uuids.length - 1)
      not_table_uuids =
        not_table_uuids == ''
          ? (not_table_uuids = 0)
          : not_table_uuids.substring(0, not_table_uuids.length - 1)
      // console.log(table_uuids, '------', field_uuids, '-------', not_table_uuids);
      valueupdate({ table_uuids, field_uuids, not_table_uuids }).then((res) => {
        if (res.code == 200) {
          this.getdetail()
          this.$Message({
            text: this.$t('message_The_operation_was_successful'),
          })
          this.handleEdit()
        }
        this.btnIsLoading = false
      })
    },
    async cancel () {
      this.getdetail()
      this.handleEdit()
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'valueIntconfig',
      //     })
      //   })
      //   .catch((err) => { })
    },
  },
  computed: {},
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit value internationalization'
          this.$store.commit('set_page_title', 'label_edit value internationalization')
        }
        else {
          this.$route.meta.title = 'label_view value internationalization'
          this.$store.commit('set_page_title', 'label_view value internationalization')
        }
      }, immediate: true
    }
  },
}
</script>

<style scoped></style>
